import { render, staticRenderFns } from "./Deck.vue?vue&type=template&id=31193da1&scoped=true&"
import script from "./Deck.vue?vue&type=script&lang=js&"
export * from "./Deck.vue?vue&type=script&lang=js&"
import style0 from "./Deck.vue?vue&type=style&index=0&id=31193da1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31193da1",
  null
  
)

/* custom blocks */
import block0 from "./Deck.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports